import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IoClose from "../../assets/icons/cross";
import { handleApiRequest } from "../../services/handleApiRequest";
import { getQuoteOfTheDay } from "../../redux/common/thunk";
import { manageQuoteModal } from "../../redux/common/slice";

export default function QuotePop({ initialData }) {
  const dispatch = useDispatch();
  const { openQuoteModal } = useSelector((state) => state.common);

  const [show, setShow] = useState(true);
  const [quote, setQuote] = useState(initialData?.quoteOfTheDay || {});

  const handleClose = (e) => {
    e.stopPropagation();
    setShow(false);
  };

  const showQuote = () => {
    setShow(false);
    dispatch(manageQuoteModal(quote));
  };

  useEffect(() => {
    if (quote?.body) return;
    (async () => {
      const response = await handleApiRequest(getQuoteOfTheDay);
      if (response.status && response?.data?.data) {
        setQuote(response?.data?.data || {});
      }
    })();
  }, [quote]);

  return (
    <>
      {show && !openQuoteModal ? (
        <div
          className="quotePop max-w-400 pointer border-bottom-0 rounded-top-1 position-fixed bottom-0 start-50 bg-primary translate-middle-x d-none d-sm-block"
          onClick={showQuote}>
          <div className="px-3 py-1 text-white">
            <IoClose
              className="quotePopCloseIcon position-absolute width-20 height-20"
              onClick={handleClose}
            />
            <p className="my-3 text-center truncate-3">{quote.body}</p>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}
